import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { startCase, intersection } from 'lodash';
import LootWeaponsProperties from '@/pages/Loot/LootWeaponsProperties.vue';
import VueMarkdown from 'vue-markdown';
import TextEditor from '@/components/TextEditor.vue';
import { isCharacterWeaponType, isCharacterArmorType, isCharacterEnhancedItem } from '@/types/completeCharacterTypes';
let CharacterSheetEquipmentPanel = class CharacterSheetEquipmentPanel extends Vue {
    constructor() {
        super(...arguments);
        this.startCase = startCase;
        this.isCharacterEnhancedItem = isCharacterEnhancedItem;
    }
    get isEquippable() {
        return this.isNotCustom(this.item)
            ? (isCharacterWeaponType(this.item) || isCharacterArmorType(this.item))
            : this.item.equipmentCategory !== 'Gear';
    }
    get equipmentPath() {
        return this.isCustomEquipment ? 'customEquipment' : 'equipment';
    }
    get atAttunementLimit() {
        return this.isNotCustom(this.item) &&
            isCharacterEnhancedItem(this.item) &&
            !this.item.attuned &&
            this.attunement.current + (intersection(this.item.rarityOptions, ['Legendary', 'Artifact']).length > 0 ? 2 : 1) > this.attunement.maximum;
    }
    isNotCustom(item) {
        return !this.isCustomEquipment;
    }
    updateQuantity(newQuantity) {
        const fixedQuantity = Math.max(0, parseInt(newQuantity) || 0);
        this.$emit('updateCharacter', { [this.equipmentPath]: { [this.index]: { quantity: fixedQuantity } } });
    }
    getWeaponDamage(weapon) {
        return weapon.damageNumberOfDice ? `${weapon.damageNumberOfDice}d${weapon.damageDieType} ${weapon.damageType}` : 'Special';
    }
};
__decorate([
    Prop(Object)
], CharacterSheetEquipmentPanel.prototype, "item", void 0);
__decorate([
    Prop(Number)
], CharacterSheetEquipmentPanel.prototype, "index", void 0);
__decorate([
    Prop(Object)
], CharacterSheetEquipmentPanel.prototype, "attunement", void 0);
__decorate([
    Prop(Boolean)
], CharacterSheetEquipmentPanel.prototype, "isCustomEquipment", void 0);
CharacterSheetEquipmentPanel = __decorate([
    Component({
        components: {
            LootWeaponsProperties,
            VueMarkdown,
            TextEditor
        }
    })
], CharacterSheetEquipmentPanel);
export default CharacterSheetEquipmentPanel;
